import { _ as __rest } from '../../../tslib.es6-17e0406b.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { ListItem, Button, Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const PREFIX = 'NavItem';
const classes = {
    item: `${PREFIX}-item`,
    itemLeaf: `${PREFIX}-itemLeaf`,
    button: `${PREFIX}-button`,
    buttonLeaf: `${PREFIX}-buttonLeaf`,
    icon: `${PREFIX}-icon`,
    title: `${PREFIX}-title`,
    active: `${PREFIX}-active`,
};
const StyledListItem = styled(ListItem)(({ theme }) => ({
    [`&.${classes.item}`]: {
        display: 'block',
        paddingTop: 0,
        paddingBottom: 0,
    },
    [`&.${classes.itemLeaf}`]: {
        display: 'flex',
        paddingTop: 0,
        paddingBottom: 0,
    },
    [`& .${classes.button}`]: {
        color: theme.palette.text.secondary,
        padding: '10px 8px',
        justifyContent: 'flex-start',
        textTransform: 'none',
        letterSpacing: 0,
        width: '100%',
    },
    [`& .${classes.buttonLeaf}`]: {
        color: theme.palette.text.secondary,
        padding: '10px 8px',
        justifyContent: 'flex-start',
        textTransform: 'none',
        letterSpacing: 0,
        width: '100%',
        fontWeight: theme.typography.fontWeightRegular,
        '&.depth-0': {
            '& $title': {
                fontWeight: theme.typography.fontWeightMedium,
            },
        },
        '&.depth-1': {
            paddingLeft: 40,
        },
    },
    [`& .${classes.icon}`]: {
        display: 'flex',
        alignItems: 'center',
        marginRight: theme.spacing(1),
    },
    [`& .${classes.title}`]: {
        marginRight: 'auto',
        fontWeight: theme.typography.fontWeightRegular,
        display: 'inline-block',
        width: '100%',
        textAlign: 'left',
    },
    [`& .${classes.active}`]: {
        color: theme.palette.secondary.main,
        '& $title': {
            fontWeight: theme.typography.fontWeightMedium,
        },
        '& $icon': {
            color: theme.palette.secondary.main,
        },
    },
}));
const NavItem = (_a) => {
    var { title, href = '', depth = 0, children, icon: Icon, className, open: openProp, info: Info, linkExterno = false } = _a, rest = __rest(_a, ["title", "href", "depth", "children", "icon", "className", "open", "info", "linkExterno"]);
    const [open, setOpen] = useState(openProp);
    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };
    let paddingLeft = 8;
    if (depth > 0) {
        paddingLeft = 32 + 8 * depth;
    }
    const style = { paddingLeft };
    if (children) {
        return (jsxs(StyledListItem, Object.assign({ className: clsx(classes.item, className), disableGutters: true }, rest, { children: [jsxs(Button, Object.assign({ className: classes.button, onClick: handleToggle, sx: style }, { children: [Icon && jsx(Icon, { className: classes.icon, size: "20" }), jsx("span", Object.assign({ className: classes.title }, { children: title })), open ? (jsx(ExpandLessIcon, { color: "inherit" })) : (jsx(ExpandMoreIcon, { color: "inherit" }))] })), jsx(Collapse, Object.assign({ in: open }, { children: children }))] }), title));
    }
    if (linkExterno) {
        return (jsx(StyledListItem, Object.assign({ className: clsx(classes.itemLeaf, className), disableGutters: true }, rest, { children: jsxs(Button, Object.assign({ component: NavLink, activeClassName: classes.active, className: clsx(classes.buttonLeaf, `depth-${depth}`), sx: style, to: { pathname: href }, target: "_blank" }, { children: [Icon && jsx(Icon, { className: classes.icon, size: "20" }), jsx("span", Object.assign({ className: classes.title }, { children: title })), Info && jsx(Info, {})] })) }), title));
    }
    return (jsx(StyledListItem, Object.assign({ className: clsx(classes.itemLeaf, className), disableGutters: true }, rest, { children: jsxs(Button, Object.assign({ activeClassName: classes.active, className: clsx(classes.buttonLeaf, `depth-${depth}`), component: NavLink, exact: true, sx: style, to: href }, { children: [Icon && jsx(Icon, { className: classes.icon, size: "20" }), jsx("span", Object.assign({ className: classes.title }, { children: title })), Info && jsx(Info, {})] })) }), title));
};

export { NavItem };
